export default {
  methods: {
    async refreshPosts(path){
      this.posts = await this.$http
        .get(`/api/v1/${path}`)
        .then((res) => res.data);
    }
  }
}